import React from 'react'

import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const Icon60FirewallAlert = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg
        shapeRendering='geometricPrecision'
        fill='currentColor'
        fillRule='evenodd'
        preserveAspectRatio='xMidYMid'
        viewBox='0 0 40 48'
      >
        <path d='M39.998,17.867 C40.000,18.237 39.901,41.048 20.332,47.944 C20.326,47.946 20.319,47.945 20.313,47.947 C20.213,47.980 20.108,47.999 20.000,47.999 C19.892,47.999 19.787,47.980 19.686,47.947 C19.680,47.945 19.674,47.946 19.668,47.944 C0.102,41.048 0.000,18.237 0.002,17.867 C0.002,17.867 0.002,17.867 0.002,17.867 L0.002,8.000 C0.002,6.897 0.899,6.000 2.002,6.000 L5.654,6.000 C5.662,6.000 5.669,6.005 5.678,6.005 C5.687,6.005 5.694,6.000 5.702,6.000 C15.360,6.000 18.963,0.682 19.111,0.455 C19.297,0.173 19.613,-0.001 19.950,-0.001 C20.290,-0.001 20.706,0.172 20.890,0.458 C21.037,0.680 24.642,6.000 34.297,6.000 C34.307,6.000 34.314,6.005 34.323,6.005 C34.332,6.005 34.340,6.000 34.349,6.000 L37.998,6.000 C39.101,6.000 39.998,6.897 39.998,8.000 L39.998,17.867 C39.998,17.867 39.998,17.867 39.998,17.867 ZM37.998,17.867 L37.998,8.000 L34.349,8.000 C34.340,8.000 34.332,7.995 34.323,7.995 C34.314,7.995 34.307,8.000 34.297,8.000 C26.002,8.000 21.651,4.349 20.000,2.533 C18.350,4.349 13.999,8.000 5.702,8.000 C5.694,8.000 5.687,7.995 5.678,7.995 C5.669,7.995 5.662,8.000 5.654,8.000 L2.002,8.000 L2.002,17.867 C2.002,17.868 2.001,17.870 2.001,17.871 C2.001,17.872 2.002,17.873 2.002,17.875 C2.000,18.090 2.074,39.343 20.000,45.927 C37.958,39.335 38.000,18.090 37.998,17.875 C37.998,17.873 37.999,17.872 37.999,17.871 C37.999,17.870 37.998,17.868 37.998,17.867 ZM20.000,32.000 C19.740,32.000 19.479,31.890 19.290,31.709 C19.109,31.519 19.000,31.259 19.000,31.000 C19.000,30.739 19.109,30.479 19.290,30.289 C19.680,29.910 20.340,29.919 20.710,30.289 C20.889,30.479 21.000,30.739 21.000,31.000 C21.000,31.259 20.889,31.519 20.710,31.709 C20.519,31.890 20.260,32.000 20.000,32.000 ZM20.000,26.999 C19.447,26.999 19.000,26.553 19.000,26.000 L19.000,17.000 C19.000,16.447 19.447,15.999 20.000,15.999 C20.553,15.999 21.000,16.447 21.000,17.000 L21.000,26.000 C21.000,26.553 20.553,26.999 20.000,26.999 Z' />
      </svg>
    </IconSLIWrapper>
  )
}

Icon60FirewallAlert.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
